import "./App.css";
import { useContext } from "react";
import { WebsiteContext } from "./context/AppContext";
import FooterComponent from "./components/footer/FooterComponent";
import HelmetComponent from "./components/HelmetComponent";
import Main from "./Main.js";
import NavBarComponent from "./components/navBar/NavBarComponent";
import whatsapp from "./assets/whatsapp.png";
import call from "./assets/call2.png";
import review from "./assets/review.webp";

function App() {
  const { dark, transition, isMobileView } = useContext(WebsiteContext);
  return (
    <div
      style={{
        backgroundColor: dark ? "#ffffff" : "#ffffff",
        transition: transition,
      }}
    >
      <HelmetComponent
        title="SSS COVAI TRAVEL'S | Affordable & Comfortable Ride Anytime, Anywhere"
        name="description"
        content="We’re here for you at any time of the day or night, ensuring your travel needs are always met."
      />

      <NavBarComponent />
      <Main />
      <div
        style={{ borderBottom: "0.02px dashed gray", marginBottom: 60 }}
      ></div>
      <div
        style={{
          position: "fixed",
          bottom: 20,
          left: 20,
          zIndex: 1000,
          cursor: "pointer", 
          backgroundImage: "linear-gradient(120deg, #f6d365 0%, #fda085 100%)",
          padding: isMobileView ? 10 : 20,
          borderRadius: 10,
          display: "flex",
          flexDirection: "column",
          gap: 20, 
          boxShadow: "0 14px 10px rgba(190, 88, 88, 0.8)",
          transition:"0.5s all"
        }}
      >
        <div>
          <a
            href="https://g.page/r/Cdi61MKOmdrlEAI/review"
            target="__blank"
            style={{
              textDecoration: "none",
              color: "#000000",
              fontFamily: "Nexa-Regular",
              fontSize: 17,
            }}
          >
            <img
              src={review}
              alt="review"
              style={{ height: isMobileView ? 40 : 50, width:isMobileView ? 40 : 50 }}
            />
          </a>
        </div>
      </div>
      <div
        style={{
          position: "fixed",
          bottom: 20,
          right: 20,
          zIndex: 1000,
          cursor: "pointer", 
          backgroundImage: "linear-gradient(to top, #d5dee7 0%, #ffafbd 0%, #c9ffbf 100%)",
          padding: isMobileView ? 10 : 20,
          borderRadius: 10,
          display: "flex",
          flexDirection: "column",
          gap: 20,
          border: "0.2px solid rgb(237, 237, 237)",
          boxShadow: "0 14px 20px rgba(190, 88, 88, 0.8)",
          transition:"0.5s all"
        }}
      >
        <div>
          <a
            href="https://api.whatsapp.com/send?phone=9655590136&text=Hello%20SSS%20KOVAI%20TRAVELS%2C%20I%20would%20like%20to%20book%20a%20cab."
            target="__blank"
            style={{
              textDecoration: "none",
              color: "#000000",
              fontFamily: "Nexa-Regular",
              fontSize: 17,
            }}
          >
            <img
              src={whatsapp}
              alt="whatsapp"
              style={{ height: isMobileView ? 40 : 50, width:isMobileView ? 40 : 50 }}
            />
          </a>
        </div>
        <div>
          <a
            href="tel:+919994610392"
            style={{
              textDecoration: "none",
              color: "#000000",
              fontFamily: "Nexa-Regular",
              fontSize: 17,
            }}
          >
            <img
              src={call}
              alt="call"
              style={{ height: isMobileView ? 30 : 40, width: isMobileView ?  40 :50, marginLeft: 0 }}
            />
          </a>
        </div>
      </div>
      <FooterComponent />
    </div>
  );
}

export default App;
